import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'bn',
  months: [
    'জানুয়ারী',
    'ফেব্রুয়ারী',
    'মার্চ',
    'এপ্রিল',
    'মে',
    'জুন',
    'জুলাই',
    'আগস্ট',
    'সেপ্টেম্বর',
    'অক্টোবর',
    'নভেম্বর',
    'ডিসেম্বর',
  ],
  monthsShort: ['জানু', 'ফেব', 'মার্চ', 'এপ্রি', 'মে', 'জুন', 'জুল', 'আগ', 'সেপ', 'অক্টো', 'নভে', 'ডিসে'],
  weekdays: ['রবিবার', 'সোমবার', 'মঙ্গলবার', 'বুধবার', 'বৃহস্পতিবার', 'শুক্রবার', 'শনিবার'],
  weekdaysMin: ['র', 'সো', 'ম', 'বু', 'বৃ', 'শু', 'শ'],
  weekdaysShort: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহস্পতি', 'শুক্র', 'শনি'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM, YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM, YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM, YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM, YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM, YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM, YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s বছর পূর্বে', other: '%s বছর পূর্বে' },
    M: { one: '%s মাস আগে', other: '%s মাস আগে' },
    w: { one: '%s সপ্তাহ আগে', other: '%s সপ্তাহ আগে' },
    d: { one: '%s দিন আগে', other: '%s দিন আগে' },
    h: { one: '%s ঘন্টা আগে', other: '%s ঘন্টা আগে' },
    m: { one: '%s মিনিট আগে', other: '%s মিনিট আগে' },
    s: { one: '%s সেকেন্ড পূর্বে', other: '%s সেকেন্ড পূর্বে' },
  },
  future: {
    y: { one: '%s বছরে', other: '%s বছরে' },
    M: { one: '%s মাসে', other: '%s মাসে' },
    w: { one: '%s সপ্তাহে', other: '%s সপ্তাহে' },
    d: { one: '%s দিনের মধ্যে', other: '%s দিনের মধ্যে' },
    h: { one: '%s ঘন্টায়', other: '%s ঘন্টায়' },
    m: { one: '%s মিনিটে', other: '%s মিনিটে' },
    s: { one: '%s সেকেন্ডে', other: '%s সেকেন্ডে' },
  },
  pastLong: {
    y: { one: '%s বছর পূর্বে', other: '%s বছর পূর্বে' },
    M: { one: '%s মাস আগে', other: '%s মাস আগে' },
    w: { one: '%s সপ্তাহ আগে', other: '%s সপ্তাহ আগে' },
    d: { one: '%s দিন আগে', other: '%s দিন আগে' },
    h: { one: '%s ঘন্টা আগে', other: '%s ঘন্টা আগে' },
    m: { one: '%s মিনিট আগে', other: '%s মিনিট আগে' },
    s: { one: '%s সেকেন্ড পূর্বে', other: '%s সেকেন্ড পূর্বে' },
  },
  futureLong: {
    y: { one: '%s বছরে', other: '%s বছরে' },
    M: { one: '%s মাসে', other: '%s মাসে' },
    w: { one: '%s সপ্তাহে', other: '%s সপ্তাহে' },
    d: { one: '%s দিনের মধ্যে', other: '%s দিনের মধ্যে' },
    h: { one: '%s ঘন্টায়', other: '%s ঘন্টায়' },
    m: { one: '%s মিনিটে', other: '%s মিনিটে' },
    s: { one: '%s সেকেন্ডে', other: '%s সেকেন্ডে' },
  },
  abbr: {
    y: { one: '%sবছর', other: '%sবছর' },
    M: { one: '%sমাস', other: '%sমাস' },
    w: { one: '%sসপ্তাহ', other: '%sসপ্তাহ' },
    d: { one: '%sদিন', other: '%sদিন' },
    h: { one: '%sঘন্টা', other: '%sঘন্টা' },
    m: { one: '%sমিঃ', other: '%sমিঃ' },
    s: { one: '%sসেকেন্ড', other: '%sসেকেন্ড' },
  },
  full: {
    y: { one: '%s বছর', other: '%s বছর' },
    M: { one: '%s মাস', other: '%s মাস' },
    w: { one: '%s সপ্তাহ', other: '%s সপ্তাহ' },
    d: { one: '%s দিন', other: '%s দিন' },
    h: { one: '%s ঘন্টা', other: '%s ঘন্টা' },
    m: { one: '%s মিনিট', other: '%s মিনিট' },
    s: { one: '%s সেকেন্ড', other: '%s সেকেন্ড' },
  },
  justNow: 'এইমাত্র',
  yesterday: 'গতকাল',
  today: 'আজ',
  tomorrow: 'আগামীকাল',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'h:mm A' },
  timeRangeStyles: {
    yl: { start: 'D MMMM, YYYY', end: 'D MMMM, YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM, YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM, YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM, YYYY', end: 'D MMM, YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM, YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM, YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM, YYYY', end: 'ddd, D MMM, YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM, YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM, YYYY HH:mm', end: 'D MMM, YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM, YYYY HH:mm', end: 'D MMM, YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'bn';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
